module.exports = __webpack_public_path__ + "static/img/BJ.e200aaaa.svg";